import * as React from 'react';
import './ArSummaryCard.scss';

export interface IArSummaryCardProps {
  label: string;
  value: string;
  past: boolean;
}

const ArSummaryCard: React.SFC<IArSummaryCardProps> = props => {
  const { label, value, past } = props;
  return (
    <React.Fragment>
      <div className="row rp-ar-summary-card-row-slot">
        <p className="rp-ar-summary-card--header-detail">{label}</p>
      </div>
      <div className="row rp-ar-summary-card-row-slot">
        <p
          className={`rp-ar-summary-card--info-detail rp-ar-summary-card--info-detail${
            past ? '-past' : ''
          }`}
        >
          {value}
        </p>
      </div>
    </React.Fragment>
  );
};

export default ArSummaryCard;
